/** Moved from gql and should be deleted */
import { FancyListItem } from '../fancy-list-models';
import { Media, MediaPart, MediaType } from '../media.interface';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export type Maybe<T> = T | null;

export enum ListType {
  Normal = 'NORMAL',
  Commercial = 'COMMERCIAL',
  Power = 'power',
}

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  // tslint:disable-next-line:no-any
  DateTime: any;
};

export interface MediaArgs {
  name: string;
  url: string;
  order: number;
  mediaType: MediaType;
  contentType?: string;
  mediaPartType: MediaPart;
  metadata?: string | null;
}

// /** List create/update model */
export type ListMutationArgs = {
  /** Name of list */
  name: Scalars['String'];
  /** Description of list */
  description?: Maybe<Scalars['String']>;
  /** List media */
  media?: Maybe<Maybe<MediaArgs>[]>;
  /** Cloned list information (Required for epic show) */
  originalProductListId?: Maybe<Scalars['String']>;
  /** Define the type of the List (Required for epic show) */
  type?: Maybe<ListType>;
  /** Toggle the date change (Only for Commercial List) */
  allowedToChangeDeliveryDate?: Maybe<Scalars['Boolean']>;
  /** Order Type */
  orderType?: Maybe<Scalars['String']>;
};

export type FeedItem = {
  /** Count of unique users who has got email */
  recipientsCount?: Maybe<Scalars['Int']>;
  /** ProductList Offer */
  // offer?: Maybe<Offer>;
  /** Is active list */
  isActive: Scalars['Boolean'];
};

/** Lists paginated result */
export type Lists = {
  /** Array of list items in requested page */
  items: List[];
  /** Total count of list items available */
  total: Scalars['Int'];
};

/** List type */
export type List = UserCreatedItem &
  FeedItem & {
    /** Guid identifier of list */
    id: Scalars['String'];
    /** List type */
    type?: Maybe<ListType>;
    /** Original List type */
    originalType?: Maybe<ListType>;
    /** Number of items in the list */
    amount?: Maybe<Scalars['Int']>;
    /** Available products count */
    availableReferences?: ProductReference[];
    availableProductsCount?: Maybe<Scalars['Int']>;
    unavailableReferences?: ProductReference[];
    /** UnAvailable products count */
    unavailableProductsCount?: Maybe<Scalars['Int']>;
    /** Name of list */
    name: Scalars['String'];
    /** Description of list */
    description?: Maybe<Scalars['String']>;
    /** Main media item of the list */
    mainMedia?: Maybe<Media>;
    /** List of all media items of the list */
    media?: Maybe<Media[]>;
    /** ProductId + BrandId */
    productsReference?: Maybe<ProductReference[]>;
    /** Count of unique users who has got email */
    recipientsCount?: Maybe<Scalars['Int']>;
    /** Newsfeed Id */
    newsfeedId?: Maybe<Scalars['String']>;
    /** ProductList Offer */
    // offer?: Maybe<Offer>;
    /** Is active list */
    isActive: Scalars['Boolean'];
    /** Recipients model */
    recipients?: Maybe<Recipient>;
    /** Information on the creation of the list */
    creation: ActionInfo;
    /** Information on the update of the list */
    update: ActionInfo;
    /** Original ProductList model */
    originalProductList?: Maybe<{
      id: string;
      userEmail: string;
    }>;
    /** Toggle the date change (Only for Commercial List) */
    allowedToChangeDeliveryDate?: Maybe<Scalars['Boolean']>;
    /** Clone Offer */
    cloneOffer?: Maybe<Scalars['Boolean']>;
    /** Order Type */
    orderType?: Maybe<Scalars['String']>;
    createdAtUtc?: Maybe<Scalars['String']>;
    /** Grouping Type */
    groupingType?: Maybe<Scalars['String']>;
    welcomePromotionNewsfeedId: string | null;
    landingPageNewsfeedId: string | null;
    layout?: string | null | FancyListItem[];
    isDeleted: boolean;
  };

/** Information about ProductReference ProductId + BrandId */
export type ProductReference = {
  /** Product id */
  productId: Scalars['String'];
  /** Brand id */
  brandId: Scalars['String'];
  /** Delivery information if part of commercial list */
  deliveryInfo?: Maybe<Maybe<DeliveryInfo>[]>;
};

/** Recipients model */
export type Recipient = {
  count?: Maybe<Scalars['Int']>;
  emails: Scalars['String'][];
};

/** Look book type */
export type LookBook = {
  /** Look book id */
  id: Scalars['String'];
  /** Look book title */
  title: Scalars['String'];
  /** Newsfeed Id */
  newsfeedId?: Maybe<Scalars['String']>;
  /** Product lists in this look book */
  items: LookBookItem[];
  /** Information on the creation of the list */
  creation: ActionInfo;
  /** Original look book id */
  originalLookBookId?: Maybe<Scalars['String']>;
  /** Create lookBook time in UTC */
  createdAt: Scalars['String'];
  /** Update lookBook time in UTC */
  updatedAt: Scalars['String'];
};

/** Look book item */
export type LookBookItem = {
  /** Look book item id */
  id: Scalars['String'];
  /** Product list id */
  productListId: Scalars['String'];
  /** Product list model */
  productList: List;
  /** Order look book item in look book */
  order: Scalars['Int'];
  /** thumbnailIndex index */
  thumbnailIndex?: Maybe<Scalars['Int']>;
};

export interface DeliveryInfoInput {
  productSizeId: string;
  quantity: number;
  orderType: OrderType;
  deliveryDate: string;
  displayDateFrom?: string;
}

export interface DeliveryInfo {
  productSizeId: string;
  quantity: number;
  orderType: OrderType;
  deliveryDate: string;
  displayDateFrom?: string;
}

export enum OrderType {
  Now = 'NOW',
  Future = 'FUTURE',
}

/** Information about an action performed */
export type ActionInfo = {
  /** Date when the action was performed */
  dateUtc: Scalars['String'];
  /** User that performed the action */
  user: UserInfo;
};

/** Information about a user */
export type UserInfo = {
  /** User ID */
  id: Scalars['Int'];
  /** User externalId */
  externalId: Scalars['String'];
  /** User disply name */
  displayName?: Maybe<Scalars['String']>;
  /** User email */
  email: Scalars['String'];
  /** User profile picture */
  profilePictureUrl?: Maybe<Scalars['String']>;
};

/** Abstract type for Lists and LookBooks */
export type UserCreatedItem = {
  /** Information on the creation of the list */
  creation: ActionInfo;
  /** Information on the update of the list */
  update?: Maybe<ActionInfo>;
};
